<template>
  <data-list :payload="modelObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination">
    <v-container grid-list-xl slot="filterForm">
      <v-row>
        <v-col cols="12" lg="2" sm="4" xs="6">
          <v-btn color="primary" :disabled="modelObj.isTechRole" :to="`/${this.MODULE_URL}/actions`">{{ $t('message.common.new') }}</v-btn>
        </v-col>
        <v-col cols="12" lg="2" sm="4" xs="6">
          <v-autocomplete clearable v-model="filterObj.customerOrSupplier" autocomplete="off" :items="filterObjLists.customerTypes" item-text="name" item-value="id" :label="$t('message.customer.customerOrSupplier')" dense hide-details outlined></v-autocomplete>
        </v-col>
        <v-col cols="12" lg="2" sm="4" xs="6">
          <v-autocomplete clearable v-model="filterObj.state" autocomplete="off" :items="filterObjLists.filterStates" item-text="name" item-value="id" :label="$t('message.customer.status')" dense hide-details outlined></v-autocomplete>
        </v-col>
        <v-col cols="12" lg="2" sm="4" xs="6">
          <v-autocomplete clearable v-model="filterObj.priority" autocomplete="off" :items="filterObjLists.filterPriorities" item-text="name" item-value="id" :label="$t('message.customer.priority')" dense hide-details outlined ></v-autocomplete>
        </v-col>
        <v-col cols="12" lg="2" sm="4" xs="6">
          <v-autocomplete clearable v-model="filterObj.industry" autocomplete="off" :items="filterObjLists.filterIndustries" item-text="name" item-value="id" :label="$t('message.customer.industry')" dense hide-details outlined></v-autocomplete>
        </v-col>
        <v-col cols="12" lg="2" sm="4" xs="6" class="text-right">
          <v-text-field append-icon="search" outlined dense single-line v-model="search" :label="$t('message.common.search')" class="text-xs-right" id="searchbtn" hide-details ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </data-list>
</template>
<script>
import DataList from '@/components/DataList.vue'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      MODULE_URL: 'customers',
      modelObj: {
        isHeader: true,
        isHideAdd: false,
        hasFilters: true,
        selection: [],
        isTechRole: JSON.parse(this.$cookie.get(process.env.VUE_APP_USER)).role_id === 3,
        showSelect: true,
        addNewRoute: () => this.$router.push(`/${this.MODULE_URL}/actions`),
        list: [],
        loading: true,
        editProp: 'name',
        onedriveProp: 'name',
        editURL: (item) => `${this.MODULE_URL}/actions/${item.id}`
      },
      total: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.CRM_INDEX) ? this.$store.state.CRM_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      filterObj: {
        customerOrSupplier: 0,
        state: 0,
        priority: 0,
        industry: 0,
        page: 1
      },
      search: ''
    }
  },
  components: {
    DataList
  },
  computed: {
    ...mapState(['CRM_INDEX', 'listOfCustomerPriorities', 'listofCustomerIndustries']),
    headers () {
      return [{
        text: this.$t('message.customer.customerNumber'),
        value: 'custom_number',
        width: '10%'
      }, {
        text: this.$t('message.customer.name'),
        value: 'name',
        width: '15%'
      }, {
        text: `${this.$t('message.customer.email')}`,
        value: 'email',
        width: '15%'
      }, {
        text: `${this.$t('message.customer.status')}`,
        value: 'stateText',
        width: '15%'
      }, {
        text: `${this.$t('message.customer.priority')}`,
        value: 'priorityname',
        width: '8%'
      }, {
        text: `${this.$t('message.layout.location')}`,
        value: 'locationText',
        width: '8%'
      }, {
        text: `${this.$t('message.customer.industry')}`,
        value: 'industryname',
        width: '15%'
      }, {
        text: this.$t('message.customer.vat'),
        value: 'vat',
        width: '10%'
      }, {
        text: this.$t('message.login.language'),
        value: 'languageText',
        width: '10%'
      }, {
        text: this.$t('message.customer.iscustomer'),
        value: 'iscustomer',
        isBoolean: true,
        sortable: false,
        width: '10%'
      }, {
        text: this.$t('message.customer.issupplier'),
        value: 'issupplier',
        isBoolean: true,
        sortable: false,
        width: '10%'
      }, {
        text: this.$t('message.common.isActive'),
        value: 'isactive',
        isBoolean: true,
        sortable: false,
        width: '10%'
      }]
    },
    filterObjLists () {
      const customerTypes = [{ id: 1, name: this.$t('message.order.customer') },
        { id: 2, name: this.$t('message.order.supplier') }
      ]
      return {
        customerTypes: customerTypes,
        filterStates: this.$_listOfCustomerStates,
        filterPriorities: this.listOfCustomerPriorities,
        filterIndustries: this.listofCustomerIndustries
      }
    }
  },
  watch: {
    pagination (val) {
      const model = { type: 'CRM_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.getListHandler()
    },
    search: function (newValue, oldValue) {
      this.getListHandler()
    },
    filterObj: {
      handler (newValue, oldValue) {
        if (newValue) {
          if (newValue.customerOrSupplier) {
            if (newValue.customerOrSupplier === 1) {
              this.filterObj.iscustomer = true
              this.filterObj.issupplier = undefined
            } else {
              this.filterObj.iscustomer = undefined
              this.filterObj.issupplier = true
            }
          } else {
            this.filterObj.iscustomer = this.filterObj.issupplier = undefined
          }
          const data = { type: 'F_CUSTOMERS', data: { filter: newValue } }
          this.$store.commit('rememberFilter', data)
          this.getListHandler()
        }
      },
      deep: true
    }
  },
  mounted () {
    this.$store.dispatch('getCustomerPriority')
    this.$store.dispatch('getCustomerIndustry')
    if (!this.$formatter.isEmptyObject(this.$store.state.F_CUSTOMERS)) {
      const customerFilters = this.$formatter.cloneVariable(this.$store.state.F_CUSTOMERS)
      this.filterObj = customerFilters.filter
    }
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE_URL) {
        const payload = { ids: data.ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.modelObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.modelObj.loading = true
      this.modelObj.module = this.MODULE_URL
      this.filterObj.rowsperpage = this.pagination.itemsPerPage
      this.filterObj.descending = this.pagination.sortDesc[0]
      this.filterObj.sortby = this.pagination.sortBy[0]
      this.filterObj.search = this.search
      this.filterObj.page = this.pagination.page
      const filterModel = this.$formatter.nullOrUndefinedToOtherValue(this.filterObj, 0)
      this.$_executeApi('post', `${this.MODULE_URL}/paginate_filter`, filterModel).then(response => {
        const customersList = response.data.items
        customersList.forEach(customer => {
          customer.languageText = customer.language ? this.$_languagesList.find(x => x.value === customer.language) ? this.$_languagesList.find(x => x.value === customer.language).title : '' : ''
          customer.locationText = customer.location ? this.$_locations.find(x => x.value === customer.location) ? this.$_locations.find(x => x.value === customer.location).text : '' : ''
          customer.stateText = customer.state ? this.$_listOfCustomerStates.find(x => x.id === customer.state) ? this.$_listOfCustomerStates.find(x => x.id === customer.state).name : '' : ''
        })
        this.modelObj.loading = false
        this.modelObj.list = customersList
        this.total = response.data.total
        if (this.pagination.page > 1 && this.total <= this.pagination.itemsPerPage * (this.pagination.page - 1)) {
          this.pagination.page = 1
          this.modelObj.page = 1
        }
      })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
